//
import GUserModel from '@/models/General/GUser'

/**
 *  vendedor_id
tipo_docto
estado
fecha
fecha_min
fecha_max 
 */

//
export default [
  {
    name: 'folio',
    type: 'text-field',
    props: {
      label: 'Folio',
    },
  },
  {
    name: 'rut',
    type: 'rut-field',
    props: {
      label: 'Rut',
    },
  },
  {
    name: 'razón_social',
    type: 'text-field',
    props: {
      label: 'Razón social',
    },
  },
  {
    name: 'vendedor_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'hr_employee_name_case',
      itemValue: 'id',
      label: 'Vendedor',
      model: GUserModel,
      noAsyncSearch: true,
      noObject: true,
      paramFilter: {
        is_ground_seller: '1',
      }
    },
  },
  {
    name: 'estado',
    type: 'select',
    props: {
      items: [
        'REALIZADA',
        'PENDIENTE',
      ],
      label: 'Estado',
    },
  },
  {
    name: 'tipo_docto',
    type: 'select',
    props: {
      items: [
        'BOLETA',
        'FACTURA',
        'NOTA CREDITO',
      ],
      label: 'Tipo',
    },
  },
  {
    name: 'fecha',
    type: 'date-field',
    props: {
      fieldProps: {
        label: 'Fecha'
      }
    },
  },
  {
    name: 'fecha_max',
    type: 'date-field',
    props: {
      fieldProps: {
        label: 'Fecha maxima'
      }
    },
  },
  {
    name: 'fecha_min',
    type: 'date-field',
    props: {
      fieldProps: {
        label: 'Fecha minima'
      }
    },
  },
]